<template>
  <ReservationTop :shop="shop" :mode="mode" />
</template>

<script>
import ReservationTop from '@/components/ReservationTop'

export default {
  name: 'InShopReservation',
  components: {
    ReservationTop,
  },
  props: {
    shopId: {
      type: String,
      required: true,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    shop: null,
  }),
  watch: {
    $route() {
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.shop = await this.$api.shops(this.shopId).get()
    },
  },
}
</script>

<style></style>
